import { render, staticRenderFns } from "./MainCategory.vue?vue&type=template&id=ce2fc674&"
import script from "./MainCategory.vue?vue&type=script&lang=js&"
export * from "./MainCategory.vue?vue&type=script&lang=js&"
import style0 from "./MainCategory.vue?vue&type=style&index=0&id=ce2fc674&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports